<template lang="pug">
  .card.black
    p(v-html='viewText')
    span.pick(:class='{hidden: hidePickNumber}') {{ card.pick }}
</template>

<script>
  export default {
    name: 'black-card',
    props: {
      card: {
        type: Object,
        required: true
      },
      picks: {
        type: Array | null,
        required: false
      },
      hidePickNumber: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      replaceLast (find, replace, string) {
        const lastIndex = string.lastIndexOf(find);

        if (lastIndex === -1) {
          return string;
        }

        const beginString = string.substring(0, lastIndex);
        const endString = string.substring(lastIndex + find.length);
        return beginString + replace + endString;
      }
    },
    computed: {
      viewText() {
        let text = this.card.text

        if (!text.includes('_')) {
          text += ' _'
        }

        if (this.picks && this.picks.length) {
          for (const pick of this.picks) {
            console.log(pick)
            text = text.replace(/_/, `<span class="placeholder">${this.replaceLast('.', '', pick.text)}</span>`)
          }
        } else {
          text = text.replace(/_/g, `<span class="placeholder">_________</span>`)
        }

        return text
      }
    },
  }
</script>

<style lang="sass">
  @import ../assets/css/var

  span.pick
    width: 2em
    height: 2em
    display: flex
    justify-content: center
    align-items: center
    border: solid 2px $white
    border-radius: 50%
    margin-top: $margin
    // background-color: $white
    // color: $black

    &.hidden
      display: none

  span.placeholder
    color: $blue
</style>
